import React, { Component } from "react";
import ApiRequest from "../libs/request.js";
import { FaLock } from "react-icons/fa";

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.email = React.createRef();
    this.errorsPanel = React.createRef();
    this.state = { success: false, verifyCode: false, isLoading: false };
  }

  render() {
    const successMessage = this.state.success && (
      <div className="reset-success-message">
        <span>✓ Reset Instructions Sent</span>
        <p style={{ marginTop: "8px", fontSize: "14px" }}>
          Check your email for password reset instructions.
        </p>
      </div>
    );

    return (
      <React.Fragment>
        <div className="signin-container">
          {/* Left Panel - Intro Content */}
          <div className="signin-intro-panel">
            <div className="intro-content">
              <h1 className="intro-title">
                <span className="gradient-text">FilmFuse</span>
              </h1>
              <p className="intro-subtitle">Reset Your Password</p>
              <p className="intro-text">
                No worries! Enter your email address and we'll send you instructions to reset your password.
              </p>
              
              <div className="features-list">
                <div className="feature-item">
                  <FaLock className="feature-icon" />
                  <div className="feature-text">
                    <h4>Secure Process</h4>
                    <p>Your account is safe with us</p>
                  </div>
                </div>
                <div className="feature-item">
                  <span className="feature-icon" style={{ fontSize: "24px" }}>✉️</span>
                  <div className="feature-text">
                    <h4>Instant Email</h4>
                    <p>Receive reset link immediately</p>
                  </div>
                </div>
                <div className="feature-item">
                  <span className="feature-icon" style={{ fontSize: "24px" }}>⚡</span>
                  <div className="feature-text">
                    <h4>Quick Reset</h4>
                    <p>Create a new password in seconds</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Panel - Form */}
          <div className="signin-form-panel">
            <div className="signin-form-wrapper">
              <div className="signin-logo">
                <img
                  src="/images/filmfuse-logo.png"
                  alt="FilmFuse"
                  style={{ maxWidth: "120px", marginBottom: "30px" }}
                />
              </div>

              <div className="signin-form-content">
                <h2 className="signin-title">Forgot Your Password?</h2>
                <p className="signin-subtitle">
                  Enter your email to receive reset instructions
                </p>

                {successMessage && (
                  <div style={{ marginBottom: "20px" }}>
                    {successMessage}
                  </div>
                )}

                <div
                  className="signin-errors"
                  ref={this.errorsPanel}
                  style={{ display: "none" }}
                ></div>

                <form className="signin-form">
                  <div className="form-group">
                    <label>Email Address *</label>
                    <input
                      type="email"
                      placeholder="you@example.com"
                      ref={this.email}
                      className="form-control"
                    />
                  </div>

                  <button
                    className="signin-button"
                    onClick={this.handleResetPassword.bind(this)}
                    type="button"
                    disabled={this.state.isLoading}
                  >
                    {this.state.isLoading ? "Sending..." : "Send Reset Link"}
                  </button>

                  <div className="signin-footer">
                    <p>
                      Remember your password?{" "}
                      <a href="/login" className="signin-link">
                        Back to Login
                      </a>
                    </p>
                    <p style={{ marginTop: "8px" }}>
                      Not yet a member?{" "}
                      <a href="/signup" className="signin-link">
                        Sign Up
                      </a>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  componentDidUpdate() {
    if (this.state.errors) {
      this.errorsPanel.current.style.display = "block";
      this.errorsPanel.current.innerHTML = `<div className="error-item">${this.state.errors}</div>`;
    }
  }

  handleResetPassword() {
    this.errorsPanel.current.style.display = "none";
    this.errorsPanel.current.innerHTML = "";

    if (this.email.current.value.length < 1) {
      this.errorsPanel.current.style.display = "block";
      this.errorsPanel.current.innerHTML =
        '<div className="error-item">Email is required</div>';
      return;
    }

    this.setState({ isLoading: true });
    let params = { email: this.email.current.value };
    let apiRequest = new ApiRequest("post", "/user/forgot-password");
    apiRequest.send(params, (response) => {
      this.setState({ isLoading: false });
      let result = response.data;
      if (result.errors) {
        this.setState({ success: false, errors: result.message });
        this.errorsPanel.current.style.display = "block";
      } else {
        this.setState({ success: true, errors: "" });
        setTimeout(() => {
          window.location.href =
            "/update-password?email=" + this.email.current.value;
        }, 2000);
      }
    });
  }
}

export default ResetPassword;
